// 扫码下载链接
export const DOWNLOAD = 'https://h5.iot.a-bene.com/app-download'